var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDiagonalCorner = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30.425,
  height: 18.196
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Diagonal Corner",
  fill: "#fff",
  stroke: "#4e4e4e",
  strokeWidth: 0.5
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 204",
  d: "M29.93 8.918H.493v3.5l8.023 4.793 12.088.729 9.326-5.523Z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 205",
  d: "M15.237.289.493 8.816l8.023 4.793 12.088.729 9.326-5.523Z"
}))));
export default SvgDiagonalCorner;